import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../types/content';
export function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <figure className="flex h-full flex-col rounded-2xl border border-ink-700 bg-ink-850 p-5" style={{
    width: "264px",
    height: "175px"
  }} data-id="element-181" data-mp="2kh863rvwzm8o">
      <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-182" data-mp="2p8huyq9n2lji">
        {Array.from({
        length: 5
      }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-lime-400 text-lime-400" aria-hidden="true" data-id="element-183" data-mp="2u8vt9glfuh4c" data-mpi={index} />)}
      </div>
      <blockquote className="mt-3 text-sm leading-relaxed text-white/85" data-id="element-184" data-mp="2z7p7xccgoe63">
        “{testimonial.quote}”
      </blockquote>
      <figcaption className="mt-auto pt-3 text-xs font-semibold uppercase tracking-wide text-lime-400" data-id="element-185" data-mp="386amkwetb91l">
        {testimonial.name}
        <span className="block pt-1 font-medium normal-case tracking-normal text-white/45" data-id="element-186" data-mp="19s9c0ynjsoy5">
          {testimonial.location} · {testimonial.role}
        </span>
      </figcaption>
    </figure>;
}